import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableManyConsistencyCheckRanMonitoring } from '@api/consistencyCheck';

import { TConsistencyCheckRanGetAvailableTemplatesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_DISABLE_MANY_MONITORING, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanDisableManyMonitoring {
	disableManyMonitoring: UseMutateFunction<any, any, TConsistencyCheckRanGetAvailableTemplatesDTO, any>;
	isLoadingDisableManyMonitoring: boolean;
}

export const useMutateConsistencyCheckRanDisableManyMonitoring = ({
	onSuccess,
}: IOnSuccess): IUseMutateConsistencyCheckRanDisableManyMonitoring => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConsistencyCheckRanGetAvailableTemplatesDTO>({
		mutationKey: [CONSISTENCY_RAN_DISABLE_MANY_MONITORING],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: disableManyConsistencyCheckRanMonitoring,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.disableMonitoringConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		disableManyMonitoring: mutate,
		isLoadingDisableManyMonitoring: isLoading,
	};
};
